import { Checkbox, Col, Row } from "antd";
import { AxiosError } from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { fetchBookable } from "../../../../apis/This";
import useShop from "../../../../hooks/useShop";
import { alertError } from "../../../../shared/utils";
import { TimeDataType, TimesTag } from "../Times";
import { TimesCountTypo, TimesTitleTypo } from "../index.styled";

interface SelectionTimeComponentProps {
  date?: moment.Moment;
  initValues?: moment.Moment[];
  onChange?: (times?: moment.Moment[]) => void;
  hidden?: boolean;
}

/**
 *
 * @param param0
 * @returns
 */
export const SelectionTimeComponent: React.FC<SelectionTimeComponentProps> = ({
  date = undefined,
  initValues,
  onChange = () => void 0,
  hidden = false,
}) => {
  const { shop } = useShop();
  const [selected, setSelected] = useState<React.Key[]>([]);
  const [allCheck, setAllCheck] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);

  /**
   *  운영시간 및 예약불가 시간 조회 API
   */
  const { data, isSuccess } = useQuery(
    ["BookableTimes", date?.format("YYYYMMDD"), shop],
    () => fetchBookable(date!.startOf("date").toISOString()),
    {
      enabled: !!date,
      select: (data) => {
        const businessTimes = data.businessHourList.map((value) =>
          moment(value)
        );

        const bookableTimes = data.bookableBusinessHourList.map((value) =>
          moment(value)
        );

        return businessTimes.map((time, i) => {
          return {
            key: i + 1,
            time,
            disabled: !bookableTimes.find((bookableTime) =>
              bookableTime.isSame(time)
            ),
          } as TimeDataType;
        });
      },
      onError: (err: AxiosError) => {
        alertError(err.message);
      },
    }
  );

  /**
   * @TODO 임시 사용 중 API 오면 대체하기
   */
  useEffect(() => {
    if (date && isSuccess) {
      if (initValues && initValues.length > 0) {
        const initKeys =
          data
            ?.filter(
              ({ time, disabled }) =>
                !disabled && initValues?.find((tm) => moment(tm).isSame(time))
            )
            .map(({ key }) => key) || [];

        setSelected(initKeys);
        if (
          initKeys.length === data?.filter(({ disabled }) => !disabled).length
        ) {
          setAllCheck(true);
        }
      } else {
        setSelected([]);
        setAllCheck(false);
      }
    }
  }, [date, isSuccess, shop]);

  useEffect(() => {
    setIndeterminate(
      selected.length > 0
        ? selected.length <
            (data?.filter(({ disabled }) => !disabled).length || 0)
        : false
    );
    if (selected) {
      onChange(
        (data as TimeDataType[])
          ?.filter((item) => selected.find((key) => item.key === key))
          .map(({ time }) => time) || []
      );
    }
  }, [selected]);

  useEffect(() => {
    setSelected(
      allCheck
        ? data?.filter(({ disabled }) => !disabled).map(({ key }) => key) || []
        : []
    );
  }, [allCheck]);

  if (hidden) return <></>;

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <Row justify="space-between">
          <Col>
            <Row gutter={8}>
              <Col>
                <TimesTitleTypo>예약 불가 시간</TimesTitleTypo>
              </Col>
              <Col>
                <TimesCountTypo>{selected.length || 0} 타임</TimesCountTypo>
              </Col>
            </Row>
          </Col>
          <Col>
            <Checkbox
              checked={allCheck}
              indeterminate={indeterminate}
              onChange={(e) => setAllCheck(e.target.checked)}
            >
              전체 선택
            </Checkbox>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <TimesTag
          times={data || []}
          selectedTimes={selected}
          block
          onChange={(keys) => setSelected(keys)}
        />
      </Col>
    </Row>
  );
};
